<app-collapsible-container
    [id]="'personalData'"
    [title]="'REPERTOIRE.FORMS.PERSONAL-DATA.TITLE'"
    [icon]="'i-address-book'"
    (elementSizeModification)="elementSizeModification.emit()"
>
    <div class="form-control" *ngIf="contactTypeControl">
        <label>{{ 'REPERTOIRE.FORMS.PERSONAL-DATA.CONTACT-TYPE' | translate }}</label>
        <app-generic-select
            [config]="{
                formGroupName: 'contactType',
                choices: contactTypesChoices$ | async
            }"
            [formControl]="contactTypeControl"
            [isValid]="contactTypeControl.valid"
            [placeholder]="'REPERTOIRE.FORMS.PERSONAL-DATA.CONTACT-TYPE-PLACEHOLDER'"
            [readOnly]="readonly"
        >
        </app-generic-select>
    </div>

    <ng-container *appCheckPermissions="permissions.repertoire_is_active_switch_change">
        <div class="form-control" *ngIf="isEdit && userType !== entityTypeEnum.CONTACT">
            <app-switch-input [formControl]="isActive" [title]="'REPERTOIRE.FORMS.IS-ACTIVE.TITLE'" [readOnly]="isMyAccount || readonly">
            </app-switch-input>
        </div>
    </ng-container>

    <div *ngIf="contactType !== contactTypeEnum.ORGANIZATION && displayFields" class="form-control">
        <app-generic-radio-checkbox
            [config]="
                userType !== 'student'
                    ? {
                          formGroupName: 'genders',
                          inputType: 'radio',
                          questionChoices: adultGenders$ | async
                      }
                    : {
                          formGroupName: 'genders',
                          inputType: 'radio',
                          questionChoices: studentGenders$ | async
                      }
            "
            [formControl]="gender"
            [readOnly]="readonly"
            class="horizontal"
        >
        </app-generic-radio-checkbox>
    </div>

    <div *ngIf="userType === entityTypeEnum.RELATIVE" class="form-control">
        <label>{{ 'REPERTOIRE.FORMS.PERSONAL-DATA.RELATIONSHIP' | translate }}</label>

        <app-generic-select
            [config]="{
                formGroupName: 'relativeType',
                choices: relativeTypesChoices$ | async
            }"
            [formControl]="relationship"
            [isValid]="relationship.valid"
            [placeholder]="'REPERTOIRE.FORMS.PERSONAL-DATA.RELATIONSHIP-PLACEHOLDER'"
            [readOnly]="readonly"
        >
            <app-form-errors
                *ngIf="relationship.touched"
                [errors]="relationship.errors"
                (errorDisplay)="elementSizeModification.emit()"
            ></app-form-errors>
        </app-generic-select>
    </div>

    <div *ngIf="userType === entityTypeEnum.EMPLOYEE" class="form-control">
        <label>{{ 'REPERTOIRE.FORMS.PERSONAL-DATA.DISPLAY-NAME' | translate }}</label>
        <app-basic-input
            *ngIf="formGroup.get('displayName')"
            [formControl]="displayName"
            [icons]="'i-employee'"
            [inputConfig]="{
                placeholder: 'REPERTOIRE.FORMS.PERSONAL-DATA.DISPLAY-NAME-PLACEHOLDER',
                inputId: 'displayName',
                type: basicInputTypeEnum.TEXT
            }"
            [maxLength]="255"
            [isValid]="displayName.valid"
            [readOnly]="readonly"
        >
            <app-form-errors
                *ngIf="displayName.touched"
                [errors]="displayName.errors"
                (errorDisplay)="elementSizeModification.emit()"
            ></app-form-errors>
        </app-basic-input>
    </div>

    <div *ngIf="userType === entityTypeEnum.CONTACT && contactType === contactTypeEnum.ORGANIZATION" class="form-control">
        <label>{{ 'REPERTOIRE.FORMS.PERSONAL-DATA.NAME' | translate }}</label>
        <app-basic-input
            *ngIf="formGroup.get('name')"
            [formControl]="name"
            [icons]="'i-building'"
            [inputConfig]="{
                placeholder: 'REPERTOIRE.FORMS.PERSONAL-DATA.NAME-PLACEHOLDER',
                inputId: 'name',
                type: basicInputTypeEnum.TEXT
            }"
            [maxLength]="255"
            [isValid]="name.valid"
            [readOnly]="readonly"
        >
            <app-form-errors *ngIf="name.touched" [errors]="name.errors" (errorDisplay)="elementSizeModification.emit()"></app-form-errors>
        </app-basic-input>
    </div>

    <div class="form-control" *ngIf="userType !== entityTypeEnum.CONTACT">
        <label>{{ 'REPERTOIRE.FORMS.PERSONAL-DATA.FIRSTNAME' | translate }}</label>
        <app-basic-input
            [formControl]="firstname"
            [icons]="'i-user'"
            [inputConfig]="{
                placeholder: 'REPERTOIRE.FORMS.PERSONAL-DATA.FIRSTNAME-PLACEHOLDER',
                inputId: 'firstname',
                type: basicInputTypeEnum.TEXT
            }"
            [maxLength]="255"
            [isValid]="firstname.valid"
            [readOnly]="readonly"
        >
            <app-form-errors
                *ngIf="firstname.touched"
                [errors]="firstname.errors"
                (errorDisplay)="elementSizeModification.emit()"
            ></app-form-errors>
        </app-basic-input>
    </div>

    <div class="form-control" *ngIf="userType !== entityTypeEnum.CONTACT">
        <label>{{ 'REPERTOIRE.FORMS.PERSONAL-DATA.LASTNAME' | translate }}</label>
        <app-basic-input
            [formControl]="lastname"
            [icons]="'i-user-regular'"
            [inputConfig]="{
                placeholder: 'REPERTOIRE.FORMS.PERSONAL-DATA.LASTNAME-PLACEHOLDER',
                inputId: 'lastname',
                type: basicInputTypeEnum.TEXT
            }"
            [maxLength]="255"
            [isValid]="lastname.valid"
            [readOnly]="readonly"
        >
            <app-form-errors
                *ngIf="lastname.touched"
                [errors]="lastname.errors"
                (errorDisplay)="elementSizeModification.emit()"
            ></app-form-errors>
        </app-basic-input>
    </div>

    <!--CONTACTS 'PERSON' FIELDS-->
    <div class="form-control" *ngIf="userType === entityTypeEnum.CONTACT && contactType === contactTypeEnum.PERSON">
        <label>{{ 'REPERTOIRE.FORMS.PERSONAL-DATA.FIRSTNAME' | translate }}</label>
        <app-basic-input
            [formControl]="firstname"
            [icons]="'i-user'"
            [inputConfig]="{
                placeholder: 'REPERTOIRE.FORMS.PERSONAL-DATA.FIRSTNAME-PLACEHOLDER',
                inputId: 'firstname',
                type: basicInputTypeEnum.TEXT
            }"
            [maxLength]="255"
            [isValid]="firstname.valid"
            [readOnly]="readonly"
        >
            <app-form-errors
                *ngIf="firstname.touched"
                [errors]="firstname.errors"
                (errorDisplay)="elementSizeModification.emit()"
            ></app-form-errors>
        </app-basic-input>
    </div>

    <div class="form-control" *ngIf="userType === entityTypeEnum.CONTACT && contactType === contactTypeEnum.PERSON">
        <label>{{ 'REPERTOIRE.FORMS.PERSONAL-DATA.LASTNAME' | translate }}</label>
        <app-basic-input
            [formControl]="lastname"
            [icons]="'i-user-regular'"
            [inputConfig]="{
                placeholder: 'REPERTOIRE.FORMS.PERSONAL-DATA.LASTNAME-PLACEHOLDER',
                inputId: 'lastname',
                type: basicInputTypeEnum.TEXT
            }"
            [maxLength]="255"
            [isValid]="lastname.valid"
            [readOnly]="readonly"
        >
            <app-form-errors
                *ngIf="lastname.touched"
                [errors]="lastname.errors"
                (errorDisplay)="elementSizeModification.emit()"
            ></app-form-errors>
        </app-basic-input>
    </div>
    <!--END CONTACTS 'PERSON' FIELDS-->

    <div *ngIf="userType !== entityTypeEnum.STUDENT && displayFields" class="form-control">
        <label
            >{{
                (userType === entityTypeEnum.RELATIVE || userType === entityTypeEnum.CONTACT
                    ? 'REPERTOIRE.FORMS.PERSONAL-DATA.RELATIVE-EMAIL'
                    : 'REPERTOIRE.FORMS.PERSONAL-DATA.EMAIL'
                ) | translate
            }}{{
                userType === entityTypeEnum.PARENT || userType === entityTypeEnum.CONTACT || userType === entityTypeEnum.RELATIVE ? '' : '*'
            }}</label
        >
        <app-basic-input
            *ngIf="formGroup.get('email')"
            [formControl]="email"
            [icons]="'i-mail'"
            [inputConfig]="{
                placeholder:
                    userType === entityTypeEnum.CONTACT && contactType === contactTypeEnum.ORGANIZATION
                        ? 'REPERTOIRE.FORMS.PERSONAL-DATA.EMAIL-ORGANIZATION-PLACEHOLDER'
                        : 'REPERTOIRE.FORMS.PERSONAL-DATA.EMAIL-PERSON-PLACEHOLDER',
                inputId: 'email',
                type: basicInputTypeEnum.EMAIL
            }"
            [maxLength]="255"
            [isValid]="email.valid"
            [readOnly]="readonly"
        >
            <app-form-errors
                *ngIf="email.touched"
                [errors]="email.errors"
                (errorDisplay)="elementSizeModification.emit()"
            ></app-form-errors>
        </app-basic-input>
    </div>

    <div *ngIf="userType === entityTypeEnum.CONTACT && contactType === contactTypeEnum.ORGANIZATION" class="form-control">
        <label>{{ 'REPERTOIRE.FORMS.GENERAL-DATA.WEBSITE' | translate }}</label>
        <app-basic-input
            [formControl]="website"
            [inputConfig]="{
                placeholder: 'REPERTOIRE.FORMS.GENERAL-DATA.PLACEHOLDERS.WEBSITE',
                inputId: 'website',
                type: basicInputTypeEnum.URL
            }"
            [maxLength]="255"
            [isValid]="website.valid"
            [icons]="'i-globe'"
            [readOnly]="readonly"
        >
            <app-form-errors
                *ngIf="website.touched"
                [errors]="website.errors"
                (errorDisplay)="elementSizeModification.emit()"
            ></app-form-errors>
        </app-basic-input>
    </div>

    <div *ngIf="userType !== entityTypeEnum.STUDENT && displayFields" class="form-control">
        <label>{{ 'REPERTOIRE.FORMS.PERSONAL-DATA.MOBILE-NUMBER' | translate }}</label>
        <app-basic-input
            *ngIf="formGroup.get('mobileNumber')"
            [formControl]="mobileNumber"
            [icons]="'i-mobile'"
            [inputConfig]="{
                placeholder: '+32 123 45 67 89',
                inputId: 'mobileNumber',
                type: basicInputTypeEnum.TEXT
            }"
            [maxLength]="16"
            [isValid]="mobileNumber.valid"
            [readOnly]="readonly"
            (focusout)="formatPhoneNumber(mobileNumber)"
        >
            <app-form-errors
                *ngIf="mobileNumber.touched"
                [errors]="mobileNumber.errors"
                (errorDisplay)="elementSizeModification.emit()"
            ></app-form-errors>
        </app-basic-input>
    </div>

    <div *ngIf="userType !== entityTypeEnum.STUDENT && displayFields" class="form-control">
        <label>{{ 'REPERTOIRE.FORMS.PERSONAL-DATA.HOME-NUMBER' | translate }}</label>
        <app-basic-input
            *ngIf="formGroup.get('homeNumber')"
            [formControl]="homeNumber"
            [icons]="'i-phone'"
            [inputConfig]="{
                placeholder: '+32 12 34 56 78',
                inputId: 'homeNumber',
                type: basicInputTypeEnum.TEXT
            }"
            [maxLength]="15"
            [isValid]="homeNumber.valid"
            [readOnly]="readonly"
            (focusout)="formatPhoneNumber(homeNumber)"
        >
            <app-form-errors
                *ngIf="homeNumber.touched"
                [errors]="homeNumber.errors"
                (errorDisplay)="elementSizeModification.emit()"
            ></app-form-errors>
        </app-basic-input>
    </div>

    <div *ngIf="userType === entityTypeEnum.STUDENT" class="form-control">
        <label>{{ 'REPERTOIRE.FORMS.PERSONAL-DATA.BIRTHDATE' | translate }}</label>
        <app-basic-input
            *ngIf="formGroup.get('birthdate')"
            [formControl]="birthdate"
            [icons]="'i-birthday-cake'"
            [inputConfig]="{
                placeholder: '01/01/2000',
                inputId: 'birthdate',
                type: basicInputTypeEnum.DATE
            }"
            [classes]="birthdate.valid ? '' : 'placeholder'"
            [isValid]="birthdate.valid"
            [readOnly]="readonly"
        >
            <app-form-errors
                *ngIf="birthdate.touched"
                [errors]="birthdate.errors"
                (errorDisplay)="elementSizeModification.emit()"
            ></app-form-errors>
        </app-basic-input>
    </div>

    <div *ngIf="userType === entityTypeEnum.STUDENT || userType === entityTypeEnum.PARENT" class="form-control">
        <label>{{ 'REPERTOIRE.FORMS.PERSONAL-DATA.NATIONAL-NUMBER' | translate }}*</label>
        <app-basic-input
            *ngIf="formGroup.get('nationalNumber')"
            [formControl]="nationalNumber"
            [inputConfig]="{
                placeholder: '00.00.00-000.00',
                inputId: 'nationalNumber',
                type: basicInputTypeEnum.TEXT
            }"
            [maxLength]="15"
            [isValid]="nationalNumber.valid"
            [maskConfig]="nationalNumberMaskConfig"
            [readOnly]="readonly"
            [icons]="'i-passport'"
        >
            <app-form-errors
                *ngIf="nationalNumber.touched"
                [errors]="nationalNumber.errors"
                (errorDisplay)="elementSizeModification.emit()"
            ></app-form-errors>
        </app-basic-input>
    </div>

    <!-- SCHOOL -->
    <div *ngIf="userType === entityTypeEnum.STUDENT" class="form-control">
        <label>{{ 'REPERTOIRE.FORMS.PERSONAL-DATA.SCHOOL' | translate }}</label>
        <app-generic-select
            [config]="{
                formGroupName: 'school',
                choices: schoolsChoices | sortBy: 'label'
            }"
            [formControl]="school"
            [isValid]="school.valid"
            [readOnly]="true"
            [placeholder]="'REPERTOIRE.FORMS.PERSONAL-DATA.SCHOOL-PLACEHOLDER'"
        >
        </app-generic-select>
    </div>

    <!-- CLASS -->
    <div *ngIf="userType === entityTypeEnum.STUDENT" class="form-control">
        <label>{{ 'REPERTOIRE.FORMS.PERSONAL-DATA.CLASS' | translate }}</label>
        <app-generic-select
            [config]="{
                formGroupName: 'class',
                choices: classesChoices | sortBy: 'label'
            }"
            [formControl]="class"
            [isValid]="class.valid"
            [readOnly]="readonly"
            [placeholder]="'REPERTOIRE.FORMS.PERSONAL-DATA.CLASS-PLACEHOLDER'"
        >
        </app-generic-select>
    </div>

    <!-- RATE TYPE -->
    <div *ngIf="userType === entityTypeEnum.STUDENT" class="form-control">
        <label>{{ 'REPERTOIRE.FORMS.PERSONAL-DATA.RATE-TYPE' | translate }}</label>
        <app-generic-select
            [config]="{
                formGroupName: 'rateType',
                choices: rateTypesChoices$ | async
            }"
            [formControl]="rateType"
            [isValid]="rateType.valid"
            [readOnly]="readonly"
            [placeholder]="'REPERTOIRE.FORMS.PERSONAL-DATA.RATE-TYPE-PLACEHOLDER'"
        >
        </app-generic-select>
    </div>

    <div *ngIf="userType === entityTypeEnum.STUDENT" class="form-control">
        <label>{{ 'REPERTOIRE.FORMS.PERSONAL-DATA.DISCOUNT' | translate }}</label>
        <app-basic-input
            *ngIf="formGroup.get('discount')"
            [formControl]="discount"
            [inputConfig]="{
                placeholder: '10',
                inputId: 'discount',
                type: basicInputTypeEnum.TEXT
            }"
            [maxLength]="3"
            [isValid]="discount.valid"
            [readOnly]="rateType.value === 1 || rateType.value === '1' || readonly"
            [trailingSign]="'%'"
        >
        </app-basic-input>
    </div>

    <div class="form-control" *ngIf="userType !== entityTypeEnum.CONTACT && userType !== entityTypeEnum.RELATIVE && userType !== entityTypeEnum.STUDENT">
        <label>{{ 'REPERTOIRE.FORMS.PERSONAL-DATA.LANG.' + (userType !== 'student' ? 'ADULT' : 'STUDENT') | translate }}</label>
        <app-generic-select
            [config]="{
                formGroupName: 'lang',
                choices: langsChoices
            }"
            [formControl]="lang"
            [isValid]="lang.valid"
            [placeholder]="'REPERTOIRE.FORMS.PERSONAL-DATA.LANG.' + (userType !== 'student' ? 'ADULT' : 'STUDENT')"
            [readOnly]="readonly"
        >
        </app-generic-select>
    </div>
</app-collapsible-container>
